// extracted by mini-css-extract-plugin
export default {"iconTextGroup":"IconTextGroup_iconTextGroup__Jg93G","labelIcon":"IconTextGroup_labelIcon__WZ-2q","infoText":"IconTextGroup_infoText__+tVrf"};